import React from 'react';
import ReservePage from '../components/myreserve/myreserve';

function Reserve() {
  return (
    <ReservePage />
  );
}

export default Reserve;
